import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WSuperCategorySectionCCD: IClientComponentDefinition = {
  name: 'WSuperCategorySection',
  load: () =>
    import(/* webpackChunkName: 'WSuperCategorySection' */ './super-category-section.component'),
}
